const {Vue, jQuery: $} = window;

import {
	htmlDecode
} from "../_utilities";
import { ACTIONS } from "../_actions";
import {store, store$} from "../_config-store";

const activeDetails$ = store$
	.map(state => state.activeDetails);

export const options = {
	template:
	`<div id="modal-details">
		<button close v-on:click="close"></button>
		<div>
			<div>
				<h1>{{activeDetails.title}}</h1>
				<div v-html="detailsHTML"></div>
			</div>
			<div v-if="type">
				<img v-if="type === 'img'" v-bind:src="activeDetails.file">
				<div v-else-if="type==='vid'" style="position:relative; padding-bottom:56.25%; overflow:hidden;"><iframe v-bind:src="'//content.jwplatform.com/players/'+activeDetails.jwCode+'-Bwa5mKtT.html'" width="100%" height="100%" frameborder="0" scrolling="auto" allowfullscreen style="position:absolute;"></iframe></div>
			</div>
		</div>
	</div>`,
	subscriptions: function() {
		return {
			activeDetails: activeDetails$
		}
	},
	computed: {
		detailsHTML: function(){
			return htmlDecode(this.activeDetails.html);
		},
		type: function(){
			return this.activeDetails.jwCode ? 'vid' : this.activeDetails.file.length ? 'img' : undefined;
		}
	},
	methods: {
		close: function(){
			store.dispatch({
				type: ACTIONS.ACTIVE_DETAILS_CHANGE,
				data: false
			});
		},
	}
}


Vue.component('modal-details',options);